/**
 * Map tile source — one place for every map in the app.
 *
 * OpenStreetMap's own tile server (tile.openstreetmap.org) is volunteer-run and
 * reserved for light, non-commercial use; it began returning "403 Access blocked"
 * for CloudSafe. CARTO's basemaps were tried next but now serve "API KEY REQUIRED"
 * placeholder tiles. Default is Esri's World Street Map, which renders without a
 * key; a keyed provider is still the right long-term choice for a commercial app.
 *
 * For production, set a keyed provider so usage is covered by its terms, e.g.
 *   REACT_APP_MAP_TILE_URL=https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=YOUR_KEY
 *   REACT_APP_MAP_TILE_ATTRIBUTION=&copy; MapTiler &copy; OpenStreetMap contributors
 * (Stadia Maps and Thunderforest work the same way.)
 */
export const TILE_URL = process.env.REACT_APP_MAP_TILE_URL
  // Note Esri's order is {z}/{y}/{x}.
  || 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';

export const TILE_ATTRIBUTION = process.env.REACT_APP_MAP_TILE_ATTRIBUTION
  || 'Tiles &copy; Esri &mdash; Esri, HERE, Garmin, OpenStreetMap contributors, and the GIS user community';

// Only used when a URL has {s}; Esri's doesn't.
export const TILE_SUBDOMAINS = 'abc';
